<template>
    <div class="approveChart" ref="approveChart" id="approveChart" :style="{'height': processHeight+'px'}">
        <div v-for="item in stepList" :key="item._id" style="position: absolute;">
            <!-- 开始节点 -->
            <div
                v-if="item.step_type === `start_event`"
                :key="item._id"
                :id="item._id"
                :class="[`approveChart-node`, `${'approveChart-node-'+item.step_status}`, `approveChart-node-start`]"
                :style="{ top: `${item.position ? item.position.top + 30 : 30}px`, left: item.position.left+'px', zIndex: 2 }"
            >
                <p>{{item.name}}</p>
            </div>
            <!-- 结束节点 -->
            <div
                v-else-if="item.step_type === `end_event`"
                :key="item._id"
                :id="item._id"
                :class="[`approveChart-node`, `${'approveChart-node-'+item.step_status}`, `approveChart-node-end`]"
                :style="{ top: `${item.position ? item.position.top + 30 : 30}px`, left: item.position.left+'px', zIndex: 2 }"
            >
                {{item.name}}
            </div>
            <!-- 任务节点 -->
            <div
                v-else
                :key="item._id"
                :id="item._id"
                :class="[`approveChart-node`, `approveChart-node-middle`, `approveChart-node-${item.step_status}`, item.task_class === 'subflow' ? 'approveChart-node-childstarted' : '']"
                :style="{ top: `${item.position ? item.position.top + 30 : 30}px`, left: `${item.position.left}px`, zIndex: 2, }"
                @mouseenter="mouseenterStep(item)"
                @mouseleave="mouseleaveStep(item)"
            >
                <p class="middle-title">
                    {{item.name || "任务名称"}}<br>
                    {{stepMap[item.step_status](item.tasks).statusText}}
                </p>
                <div class="middle-content">
                    <i class="middle-content-left" :class="stepMap[item.step_status](item.tasks).icon.name" :style="{color: stepMap[item.step_status](item.tasks).icon.color}"></i>
                    <div class="middle-content-right">
                        <p>{{item.allUser}}</p>
                        <p>
                            <span>{{item.operate_time ? $transformDate(item.operate_time) : ""}}</span>
                            <span>{{stepMap[item.step_status](item.tasks).text}}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <!-- 步骤详情 -->
        <div
            v-if="curStep && curStep.visible"
            class="poptip"
            :style="{ top: `${curStep.position ? curStep.position.top + 30 : 30 }px`, left: `${Math.floor(curStep.position.left) + 260}px`, zIndex: 3 }"
            @mouseenter="mouseenterPoptip(curStep)"
            @mouseleave="mouseleavePoptip(curStep)"
        >
            <div class="poptip-title">
                <div class="poptip-title-inner ms-ellipsis">处理详情</div>
                <div v-if="curStep && curStep.node_remark" class="poptip-title-remark">{{curStep.node_remark}}</div>
            </div>
            <div class="poptip-body bri-scrollbar">
                <!-- 子流程实例列表 -->
                <div v-if="curStep.task_class === 'subflow'">
                    <template v-if="subFlowInstList.length > 0">
                        <div v-for="subFlowInst in subFlowInstList" :key="subFlowInst._id" class="poptip-body-item" style="cursor: pointer;" @click="clickShowSubFlow(subFlowInst)">
                            <span class="poptip-body-item-dot" :style="{ backgroundColor: subFlowInst.flow_stage === 'completed' ? 'green' : 'red' }"></span>
                            <p>【{{ subFlowInst.chart_name }}子流程】{{ subFlowInst.starter ? subFlowInst.starter.realname : "" }} </p>
                        </div>
                    </template>
                    <div v-else class="poptip-body-item">
                        <p>暂无子流程实例...</p>
                    </div>
                </div>
                <!-- 普通任务步骤详情 -->
                <div v-else>
                    <template v-if="curStep.tasks.length > 0">
                        <div v-for="detail in curStep.tasks.filter(step => step.operate_time)" :key="detail._id" class="poptip-body-item">
                            <div class="poptip-body-item-content">
                                <i class="poptip-body-item-content-left" :class="taskMap[detail.status].icon.name" :style="{color: taskMap[detail.status].icon.color}"></i>
                                <div class="poptip-body-item-content-right">
                                    <p>{{detail.user.realname || detail.user.mobile}}</p>
                                    <p>
                                        <span>{{ $transformDate(detail.operate_time) }}</span>
                                        <span>{{ stepMap[detail.status]().text }}</span>
                                    </p>
                                </div>
                            </div>
                            <div v-if="detail.opinion" class="poptip-body-item-opinion">意见：{{ detail.opinion }}</div>
                        </div>
                    </template>
                    <div v-else class="poptip-body-item">
                        <p>暂无审批信息...</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- 审批子流程图 -->
        <Modal v-model="showSubMap" width="1000" :title="curSubFlowInst && curSubFlowInst.chart_name" :footer-hide="true">
            <approveChart v-if="showSubMap" :id="curSubFlowInst._id"></approveChart>
        </Modal>
    </div>
</template>

<script>
    import "jsplumb";

    export default {
        name: "approveChart",
        props: {
            companyId: {
                type: String,
                required: true
            },
            appId: {
                type: String,
                required: true
            },
            approveData: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        data () {
            return {
                requests: {},
                roundStyle: {
                    "padding": "4px 10px 4px 4px",
                    "background": "rgba(255,244,244,1)",
                    "border-radius": "14px"
                },

                // 任务节点和连线数据
                stepList: [],
                curStep: null,
                connectionRelations: [],
                jsPlumbInstance: null,
                processHeight: 50,

                // 步骤详情
                detailList: [],
                // 子流程实例数据
                showSubMap: false,
                subFlowInstList: [],
                curSubFlowInst: null,
                taskMap: {
                    completed: {
                        icon: {
                            name: "bico-font bico-complete",
                            color: "#A0EE82"
                        }
                    },
                    other_completed: {
                        icon: {
                            name: "bico-font bico-return",
                            color: "#A0EE82"
                        }
                    },
                    waiting: {
                        icon: {
                            name: "bico-font bico-return",
                            color: "#D7D7D7"
                        }
                    },
                    rejected: {
                        icon: {
                            name: "bico-font bico-return",
                            color: "#F07D83"
                        }
                    },
                    other_rejected: {
                        icon: {
                            name: "bico-font bico-return",
                            color: "#F07D83"
                        }
                    }
                },
                stepMap: {
                    completed: () => {
                        return {
                            icon: {
                                name: "bico-font bico-complete",
                                color: "#A0EE82"
                            },
                            text: "已完成",
                            statusText: "已完成"
                        };
                    },
                    other_completed: () => {
                        return {
                            icon: {
                                name: "bico-font bico-complete",
                                color: "#A0EE82"
                            },
                            text: "已完成",
                            statusText: "已完成"
                        };
                    },
                    noview: () => {
                        return {
                            icon: {
                                name: "bico-font bico-complete",
                                color: "#A0EE82"
                            },
                            text: "未查看",
                            statusText: "未查看"
                        };
                    },
                    waiting: () => {
                        return {
                            icon: {
                                name: "bico-font bico-return",
                                color: "#D7D7D7"
                            },
                            text: "等待中",
                            statusText: "待处理"
                        };
                    },
                    rejected: () => {
                        return {
                            icon: {
                                name: "bico-font bico-return",
                                color: "#F07D83"
                            },
                            text: "已拒绝",
                            statusText: "拒绝"
                        };
                    },
                    reverted: () => {
                        return {
                            icon: {
                                name: "bico-font bico-return",
                                color: "#F07D83"
                            },
                            text: "被退回",
                            statusText: "被退回"
                        };
                    },
                    other_rejected: () => {
                        return {
                            icon: {
                                name: "bico-font bico-return",
                                color: "#F07D83"
                            },
                            text: "已拒绝",
                            statusText: "拒绝"
                        };
                    },
                    started: (tasks) => {
                        return {
                            icon: {
                                name: tasks.length > 1 ? "bico-font bico-conduct" : "bico-font bico-complete",
                                color: "#24b7e5"
                            },
                            text: tasks.length > 1 ? (tasks.filter(item => item.status === "completed").length + "人完成") : "进行中",
                            statusText: "处理中"
                        };
                    }
                },
                taskLastestTime: null,
                stepLastestTime: null
            };
        },
        filters: {},
        computed: {
            flowInstId () {
                return this.approveData.flow_inst && this.approveData.flow_inst._id;
            }
        },
        created () {},
        mounted () {
            this.init();
        },
        methods: {
            // 初始化
            init () {
                this.getFlowChartData();
            },
            initStep (steps) {
                this.stepLastestTime = null;
                this.stepList = steps.map((item, index) => {
                    item.visible = false;
                    let optionStr = item.operate_condition == "or" ? " / " : " & ";
                    item.allUser = item.verify_users.length > 2 ? `${item.verify_users.slice(0, 2).join(optionStr)} 等 ${item.verify_users.length} 人` : item.verify_users.join(optionStr);
                    if (item.step_status === "completed" && item.step_type === "user_task" && !item.operate_time) {
                        item.step_status = "noview";
                    }
                    return item;
                }) || [];
            },
            // 获取流程状态图
            getFlowChartData () {
                this.$https({
                    url: {
                        module: "flowInst",
                        name: "chart"
                    },
                    params: {
                        flow_inst: this.flowInstId
                    },
                    callback: data => {
                        // 解决接口过慢，离开当前页面后才返回数据的问题
                        if (!this.$refs.approveChart) {
                            return;
                        }

                        data.relations.forEach(item => {
                            (item.active_count === 0 && item.revert_type === "revert") || (this.connectionRelations.push(item));
                        });

                        this.initStep(data.steps);
                        // 居中显示
                        let approveChartWidth = this.$refs.approveChart.offsetWidth;
                        let middleLeft = approveChartWidth / 2 - 130;
                        if (this.stepList.length > 0) {
                            let firstStepLeft = this.stepList[0].position.left;
                            this.stepList.map((item, index) => {
                                let leftGap = middleLeft - firstStepLeft;
                                item.position.left = Math.floor(item.position.left + leftGap);
                            });
                        };

                        // 流程单元top的最大值作为父元素的宽度
                        let topList = this.stepList.map(item => item.position ? item.position.top : null);
                        this.processHeight += Math.max(...topList);
                        this.$nextTick(() => {
                            this.initJsPlumb();
                        });
                    }
                });
            },
            // 步骤节点鼠标滑入
            mouseenterStep (item) {
                item.visible = true;
                this.curStep = item;
            },
            // 步骤节点 -鼠标滑出
            mouseleaveStep (item) {
                item.visible = false;
            },
            // 步骤详情 -鼠标滑入
            mouseenterPoptip (item) {
                item.visible = true;
            },
            // 步骤详情 -鼠标滑出
            mouseleavePoptip (item) {
                item.visible = false;
            },
            // 步骤详情 -点击显示子流程状态图
            clickShowSubFlow (subFlowInst) {
                this.showSubMap = true;
                this.curSubFlowInst = subFlowInst;
            },

            // 初始化实例
            initJsPlumb () {
                jsPlumb.ready(() => {
                    // 实例化jsPlumb
                    this.jsPlumbInstance = jsPlumb.getInstance({
                        DragOptions: { cursor: "pointer", zIndex: 99 },
                        HoverPaintStyle: { strokeWidth: 3 },
                        Endpoint: "Blank",

                        Connector: ["Flowchart", { curviness: 70 }],
                        ConnectionOverlays: [["Arrow", { location: 1, width: 12, length: 12 }]],
                        Container: "approveChart"
                    });

                    this.handleRenderDrawing();
                });
                // jsPlumb.unmakeEveryTarget().unmakeEverySource();
            },
            // 渲染节点端点和连线连接
            handleRenderDrawing () {
                this.jsPlumbInstance.batch(() => {
                    // 渲染节点端点
                    this.stepList.forEach(item => {
                        this.handleAddEndpoint(item);
                    });
                    // 渲染连线连接
                    this.connectionRelations.forEach(item => {
                        let color = item.active_count === 0 ? "#c3c3c3" : (item.revert_type === "revert" ? "#ed5564" : "#24b7e5");
                        let connectInstance = this.jsPlumbInstance.connect({
                            uuids: [`${item.source}-${item.startAnchor || "Bottom"}`, `${item.target}-${item.endAnchor || "Top"}`], // 根据uuid进行连接
                            paintStyle: {
                                stroke: color,
                                strokeWidth: 1,
                                description: item.description,
                                revert_type: item.revert_type,
                                push_priority: item.push_priority,
                                revert_priority: item.revert_priority,
                                condition: item.condition
                            }
                        });
                        this.handleRenderConnectionOverlay(connectInstance, color);
                    });
                });
            },
            // 增加节点的端点
            handleAddEndpoint (node) {
                let endpointObj = {
                    maxConnections: 10 // 设置点最多可以连接几条线
                };
                // 可以作为连接线开始的点 和 结束的点
                let sourcePoint = ["Bottom", "Left", "Right"];
                let targetPoint = ["Top", "Left", "Right"];
                for (let anchor of ["Top", "Bottom", "Left", "Right"]) {
                    let referenceParams = {
                        uuid: `${node._id}-${anchor}`,
                        anchor: anchor,
                        isSource: sourcePoint.includes(anchor),
                        isTarget: targetPoint.includes(anchor)
                    };
                    this.jsPlumbInstance.addEndpoint(node._id, endpointObj, referenceParams);
                }
            },
            // 渲染单个连线样式
            handleRenderConnectionOverlay (connectInstance, color) {
                if (connectInstance) {
                    let connectItem = connectInstance.getPaintStyle();
                    if (!connectItem.description && connectItem.revert_type === "revert") {
                        connectItem.description = "退  回";
                    };

                    if (connectItem.description) {
                        connectInstance.setLabel(function (c) {
                            return `<div style="border-color: ${color};" class="over-lay-label">${connectItem.description}</div>`;
                        });
                    }
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/flow/approve/approveModal/approveChart.vue